export const ROOTS = {
  CLINIC: "/c",
  PATIENT: "/p",
  USER: "/u",
  AUTH: "/v",
  EVENTS: "/e",
};

export const USER_ROUTES = {
  DETAILS: "details",
  PROFILE: "profile",
  SECURITY: "security",
  CALENDER: "calender",
  COMPLIANCE: "compliance",
  TEAMACCESS: "team-access",
  APP_MODES: "mode",
  QUESTIONNAIRE: "questionnaire",
  INVITES: "invites",
  AUTOJOIN: "auto-join",
  QES: "qes",
};

export const CLINIC_ROUTES = {
  PATIENTS: "patients",
  PATIENT_DETAILS: "patients/:patientId",
  PATIENT_IMPORT_CONFIG: "patients/import/:importId",
  PATIENTS_DATA_MANAGEMENT: "patients/data-management",
  PATIENTS_TAGS: "patients/tags",
  PATIENTS_PROCEDURES: "patients/procedures",
  PATIENTS_TREATMENT_PLANS: "patients/treatment-plans",
  PATIENTS_MEDICATIONS: "patients/medications",
  PATIENTS_DOCUMENTS: "patients/documents",
  APPOINTMENTS: "appointments",
  STATISTICS: "statistics",
  MINI_SITE: "mini-site",
  WORKFLOWS: "workflows",
  PAYMENTS: "payments",
  PERKS: "perks",
  SETTINGS: "settings",
};

export const SETTINGS_ROUTES = {
  DETAILS: "details",
  LOCATIONS: "locations",
  SUBSCRIPTION_PLAN: "subscription",
  MEMBERS_PERMISSIONS: "members-permissions",
  COMPLIANCE: "compliance",
  INVOICES: "invoices",
  INTEGRATIONS: "integrations",
  PAYOUTS: "payouts",
};

export const PATIENT_ROUTES = {
  DASHBOARD: "dashboard",
};

export const EVENT_ROUTES = {
  DASHBOARD: "dashboard",
  EVENTS: "events",
  EVENT_DETAILS: "events/:eventId",
  ATTENDEES: "attendees",
  ATTENDEE_DETAILS: "attendees/:attendeeId",
  ATTENDEE_TAGS: "attendee-tags",
  ATTENDEE_TAG_DETAILS: "attendee-tags/:tagId",
  INSTRUCTORS: "instructors",
  INSTRUCTOR_DETAILS: "instructors/:instructorId",
  TRANSACTIONS: "transactions",
  PAYOUTS: "payouts",
  BRANDS: "brands",
  BRAND_DETAILS: "brands/:brandId",
  VENUES: "venues",
  VENUE_DETAILS: "venues/:venueId",
  PROFILE: "profile",
  SETTINGS: "settings",
};

export const ROUTES = {
  REGISTER: "/v/register",
  REGISTER_CHECK_EMAIL: "/v/register/check-email",
  LOGIN: "/v/login",
  LOGOUT: "/v/logout",
  PASSWORD_RESET: "/v/password-reset",
  OTT: "/v/ott",
  TWO_FACTOR: "/v/login/two-factor",
  ALTERNATIVE_EMAIL_VERIFY: "/v/alternative-email",
  JOIN: "/v/join",
  QES_CONNECT: "/v/qes-connect",
};

export const REGISTER_STEPS = {
  OPTIONS: "options",
  FORM: "form",
  GOOGLE_SIGN_UP: "google_sign_up",
};
